import { AutogenModelDetentionHistoryLookup, AutogenRowDetentionHistoryLookup } from "./autogen/AutogenModelDetentionHistoryLookup";

export class ModelDetentionHistoryLookup extends AutogenModelDetentionHistoryLookup<RowDetentionHistoryLookup> {
	constructor() {
		super(RowDetentionHistoryLookup);
	}
}

export class RowDetentionHistoryLookup extends AutogenRowDetentionHistoryLookup {
}